import(/* webpackMode: "eager", webpackExports: ["DialogProvider"] */ "/app/apps/external-assistance/src/hooks/useDialog/provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.26_@babel+core@7.26.10_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/[lang]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/app/apps/external-assistance/src/theme/global.external.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-hot-toast@2.5.2_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@18.3.1/node_modules/react-loading-skeleton/dist/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/react-loading-skeleton@3.5.0_react@18.3.1/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager", webpackExports: ["PasswordField"] */ "/app/packages/ui/src/components/form/fields/Password/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PinField"] */ "/app/packages/ui/src/components/form/fields/Pin/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiSelectField"] */ "/app/packages/ui/src/components/form/fields/select/Multi/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SelectField"] */ "/app/packages/ui/src/components/form/fields/select/Single/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Fab"] */ "/app/packages/ui/src/components/navigation/Fab/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Backdrop"] */ "/app/packages/ui/src/components/overlay/Backdrop/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/app/packages/ui/src/components/surfaces/Accordion/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorMessage"] */ "/app/packages/ui/src/components/utils/error/Message/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/app/packages/ui/src/components/utils/Tooltip/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/src/theme/global.css");
